module.exports = __webpack_public_path__ + "images/stable-active.825177ca219accb2d44b076c0af2d77d.png";